import { AssetDto } from '@/shared/lib/sj-orm/models/asset.dto';
import { compareStrings } from '@/shared/utils/strings';

import { getAssetValueMultiplier } from './common';

export const assetFieldSorter = {
  // nickname / nickName
  nickname: (a1: AssetDto, a2: AssetDto) =>
    compareStrings(a1.nickname ?? a1.nickName, a2.nickname ?? a2.nickName),
  country: (a1: AssetDto, a2: AssetDto) => compareStrings(a1.country, a2.country),
  category: (a1: AssetDto, a2: AssetDto) => compareStrings(a1.category, a2.category),
  value: (a1: AssetDto, a2: AssetDto) => {
    const value1 = (a1.purchaseValue?.value ?? 0) * getAssetValueMultiplier(a1);
    const value2 = (a2.purchaseValue?.value ?? 0) * getAssetValueMultiplier(a2);

    if (a1.isTest && !a2.isTest) {
      return 1;
    }

    if (!a1.isTest && a2.isTest) {
      return -1;
    }

    return value1 - value2;
  },
};
